<header [hidden]="!showLoginHeader" class="header">
    <nav class="navbar clearfix">
        <div class="logo-box">
            @if(showLogo == false){
            <a class="navbar-brand logo" id="logo">
                <img style="font-size: 8px; max-height: 45px;" src="assets/img/Group 2047@3x.png" alt="ICON"
                    class="lg-logo" />
            </a>
            } @else {
            <a class="navbar-brand logo" id="logo1">
                <img style="font-size: 8px; max-height: 45px;" src="assets/img/Group 2047@3x.png" alt="ICON"
                    class="lg-logo" />
            </a>
            }
        </div>
        <div class="d-flex align-items-center justify-content-between">
            <div class="header-right-part" (click)="head()">
                <button class="btn btn-toggle" type="button" style="color:#000">
                    <em class="fa fa-bars"></em>
                </button>
            </div>
            <div class="d-flex align-items-center me-3">
                <a class="navbar-brand logo" style="width: 100%; display: inline-flex; justify-content: center;">
                    <img class="lg-logo" [src]="profileData?.profilePic || 'assets/img/profile-img.jpg'" alt="image"
                        style=" border-radius: 50px; cursor: pointer;width: 50px;" (click)="adminProfile()"
                        (error)="onImageError($event)" />
                </a>
                <a class="side_menu top-menu" (click)="logOutModal()">
                    <i class="fa fa-sign-out" aria-hidden="true"></i>
                    <span class="side_page_name head_color">Log Out</span>
                </a>
            </div>
        </div>


    </nav>
</header>

<header [hidden]="showLoginHeader" class="header">
    <nav class="navbar clearfix">
        <div class="logo-box" style="background: none">
            <a class="navbar-brand logo" [routerLink]="['login']">
                <img style="font-size: 8px; max-height: 45px;" src="assets/img/Group 2047@3x.png" alt="ICON"
                    class="lg-logo" />
            </a>
        </div>
    </nav>
</header>

<!-- logout modal -->
<div class="modal fade global-modal reset-modal" id="logoutModal">
    <div class="modal-dialog max-WT-500">
        <form class="change_password">
            <div class="modal-content">
                <div class="modal-header d-block text-center modal-header-custm">
                    <h5 class="modal-title d-inline-block">Logout?</h5>
                </div>
                <div class="modal-inner-content">
                    <div class="modal-body">
                        <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                            <div class="w-100">
                                <p>Are you sure you want to logout?</p>
                                <div class="modal-btn-box">
                                    <button type="button" class="btn btn-theme" (click)="logout()">YES</button>
                                    <button type="button" style="min-width: 100px;" class="btn btn-danger ms-2"
                                        data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>